<template>
    <basic-container>
      <el-form
        :model="searchForm"
        ref="searchFormRef"
        label-width="100px"
        label-suffix=":"
        v-show="searchBoxFlag"
      >
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="服务网点" prop="name">
              <el-input
                clearable
                v-model="searchForm.name"
                placeholder="服务网点"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="负责人" prop="institutionUser">
              <el-input
                clearable
                v-model="searchForm.institutionUser"
                placeholder="负责人"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <div style="float:right">
              <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
                搜索
              </el-button>
              <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <avue-crud
        :option="option"
        :table-loading="loading"
        :data="data"
        :page.sync="page"
        ref="crud"
        @on-load="onLoad"
        @current-change="currentChange"
        @size-change="sizeChange"
        @refresh-change="onLoad"
        @selection-change="selectionChange"
        @cell-click="cellClick"
        :cell-style="cellStyle"
      >
        <template slot="menuRight">
          <searchFromShow
            :searchBoxFlag.sync="searchBoxFlag"
            :removeHeight="searchHeight"
            :option="option"
            reduceHeight="20"
            :refOption="$refs.crud"
          ></searchFromShow>
        </template>

        <template slot="menuLeft">
          <el-button type="primary" v-if="permission.nursingHomeManage_add"   icon="el-icon-plus" size="small" @click="addNursingForm"> 新 增</el-button>
          <el-button type="primary" plain v-if="permissionList.largeScreenBtn" size="small" @click="setLargeScreen">多网点大屏</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <!-- <el-button v-if="permission.nursingHomeManage_view"   type="text" size="small" @click="viewRecord(scope.row)">查看 </el-button> -->
          <el-button v-if="permission.nursingHomeManage_edit" type="text" size="small" @click="editRecord(scope.row)">编辑 </el-button>
          <el-button v-if="permission.nursingHomeManage_del"   type="text" size="small" @click="delRecord(scope.row.id)">删除 </el-button>
          <el-button v-if="scope.row.largeScreenAddress" type="text" size="small"  @click="handleScreen(scope.row)">大屏 </el-button>
          <el-button v-if="permission.nursingHomeManage_estimate" type="text" size="small" @click="estimate(scope.row)">评估模版 </el-button>
        </template>
      </avue-crud>
      <hr-dialog
      :title="nursingFormTittle"
      :allowFull="false"
      width="60%"
      :visible.sync="nursingFormVisible"
    >
      <template slot="body">
        <NursingForm
        :model="formModel"
        :row="formRow"
          @cancle="recordCancle"
          v-if="nursingFormVisible"
          @success="recordSuccess"
          :projectId="this.searchForm.projectId"
        ></NursingForm>
      </template>
    </hr-dialog>
    <hr-dialog
      title="评估模版"
      :allowFull="false"
      width="60%"
      :visible.sync="estimateVisible"
    >
      <template slot="body">
        <EstimateForm
        :row="estimateRow"
          @cancle="estimateCancle"
          v-if="estimateVisible"
          @success="estimateSuccess"
        ></EstimateForm>
      </template>
    </hr-dialog>
    <!-- 多网点大屏弹框 -->
    <el-dialog
      title="多网点大屏"
      width="60%"
      :visible.sync="sitesDialogShow"
      :before-close="beforeCloseDialog"
      @close="closeDialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <sites-form
        v-if="sitesDialogShow"
        :rowData="rowData"
        :projectId="this.searchForm.projectId"
        @close="closeDialog"
      />
    </el-dialog>
    </basic-container>
  </template>
  <script>
  import { getProjectList } from '@/api/crmedical/project/project';
  import { nursingPage, nurforRemove } from '../api/nursingManage.js';
  import NursingForm from './nursingForm.vue';
  import EstimateForm from './estimateForm.vue';
  import SitesForm from './sites-form.vue';
  import searchFromShow from '@/components/search-form-show/index';
  import { mapGetters } from 'vuex';
  export default {
    components: { searchFromShow ,NursingForm, EstimateForm, SitesForm},
    data() {
      return {
        editVisible:false,
        formModel:'add',
        isImportDialogShow: false,
        settingTotalWarnVisible: false,
        nursingFormVisible: false,
        estimateVisible: false,
        printVisible: false,
        addOrderVisible: false,
        nursingFormVisible: false,
        nursingFormTittle: '编辑',
        nursingFormModel: 'view',
        rowInfo: {},
        searchForm: {
          name:'',
          institutionUser: ''
        },
        projectList: [],
        option: {
          selection: true,
          select: true,
          index: true,
          indexLabel: '#',
          page: true,
          height: 'auto',
          calcHeight: 'auto',
          align: 'left',
          menu: true,
          addBtn: false,
          editBtn: false,
          delBtn: false,
          border: true,
          column: [
            {
              label: '服务网点',
              prop: 'name',

            },
            {
              label: '网点编码',
              prop: 'code',
            },
            {
              label: '网点性质',
              prop: 'propertyName',
            },
            {
              label: '负责人',
              prop: 'institutionUser',
              width: 100
            },
            {
              label: '联系电话',
              prop: 'institutionUserTel',
            },
            {
              label: '网点地区',
              prop: 'regionName',
            },
            {
              label: '网点地址',
              prop: 'address',
            },
          ],
        },
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        data:[],
        loading: false,
        searchBoxFlag: true,
        searchHeight: '',
        selectionList: [],
        recordIds: [],
        formRow:{},
        estimateRow: {},
        sitesDialogShow: false,
        rowData: [],
      };
    },
    created() {

      this.initData();
    },
    computed: {
      ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.nursingHomeManage_add, false),
        editBtn: this.vaildData(this.permission.nursingHomeManage_edit, false),
        delBtn: this.vaildData(this.permission.nursingHomeManage_del, false),
        viewBtn: this.vaildData(this.permission.nursingHomeManage_view, false),
        largeScreenBtn: this.vaildData(this.permission.nursingHomeManage_largeScreen, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
    },
    mounted() {
      this.calcHeight();
      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    activated() {
      // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
      this.$nextTick(() => {
        this.$refs.crud.refreshTable();
      });
    },
    methods: {
      closeDialog() {
        this.sitesDialogShow = false;
        this.rowData = {};
      },
      /* 关闭表单弹框的确认框 */
      beforeCloseDialog(done) {
        this.$confirm(' 是否关闭继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (typeof done == 'function') {
              done();
            }
          })
          .catch(() => {});
      },
      setLargeScreen() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.sitesDialogShow = true;
        this.rowData = this.selectionList;
      },
      addNursingForm(){
        this.nursingFormTittle="新增"
        this.formModel ="add"
        this.nursingFormVisible = true
      },
      importSuccess(){
        this.isImportDialogShow = false
        this.onLoad()
      },
      searchRecord() {
        this.page.currentPage = 1;

        this.onLoad();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      // 数据导出

      editRecord(row){
        this.nursingFormTittle="修改"
        this.formModel='edit'
        this.formRow = row
        this.nursingFormVisible = true;
      },

      estimate(row) {
        this.estimateRow = row
        this.estimateVisible = true
      },

      recordCancle() {
        this.editVisible = false
        this.nursingFormVisible = false;
        this.settingTotalWarnVisible = false;
      },
      recordSuccess() {
        this.editVisible = false
        this.nursingFormVisible = false;
        this.settingTotalWarnVisible = false;
        this.onLoad();
      },

      estimateCancle() {
        this.estimateVisible = false
        this.estimateRow = {};
      },
      estimateSuccess() {
        this.estimateVisible = false
        this.estimateRow = {};
        this.onLoad();
      },

      handleScreen(row) {
        window.open(row.largeScreenAddress + '&nursinghomeId=' + row.id)
      },

      viewRecord(row) {
        this.nursingFormTittle = '查看';


        this.formModel = 'view';
        this.formRow = row;
        this.nursingFormVisible = true;
      },

      delRecord(id) {
      this.$confirm(' 是否删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          nurforRemove(id).then((re) => {
            this.$message.success('删除成功');
            this.onLoad();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },



      searchClear() {
        this.tool.clearObject(this.searchForm);

      },

      calcHeight() {
        this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
        this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
      },

      cellClick(row, column) {
      if (column.label === '服务网点') {
        console.log(row);
        if (row.name) {
          this.nursingFormTittle = '查看';
          this.formModel = 'view';
          this.formRow = row;
          this.nursingFormVisible = true;
        }
      }
    },
    cellStyle({column}) {
      if (column.label === '服务网点') {
        return {
          color: '#409eff',
          cursor: 'pointer',
        };
      }
    },
      initData() {


      },

      onLoad() {
        nursingPage(
            Object.assign(
              {},
              { current: this.page.currentPage, size: this.page.pageSize },
              this.searchForm
            )
          )
            .then(({ data }) => {
              this.data = data.records;
              this.page.total = data.total;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
      },
    },
  };
  </script>

  <style scoped>
  ::v-deep .avue-crud__right {
    display: flex;
  }
  ::v-deep .el-drawer__body {
    overflow: scroll !important;
  }
  ::v-deep .avue-crud .el-form-item {
    display: block;
  }

  .money {
    text-align: right;
  }
  .txtOver {
    display: -webkit-box;
    overflow: hidden; /*超出隐藏*/
    text-overflow: ellipsis; /*隐藏后添加省略号*/
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  </style>
  <style>
  #nursingForm > div > div.el-dialog__body {
    height: calc(100% - 100px);
  }
  </style>
